module.exports = __webpack_public_path__ + "img/usuario.5b16c0e5.png";